import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Taskboard sprint: drag dei task fra le 3 celle di stato della PROPRIA
// story (group per-story: i task non attraversano le righe). Il drop
// persiste lo stato via PATCH move; su errore l'elemento torna indietro.
export default class extends Controller {
  static targets = ["cell"]

  connect() {
    this.sortables = this.cellTargets.map((cell) =>
      Sortable.create(cell, {
        group: cell.dataset.group,
        animation: 150,
        ghostClass: "opacity-30",
        onEnd: this.onEnd.bind(this)
      })
    )
  }

  disconnect() {
    this.sortables.forEach((sortable) => sortable.destroy())
  }

  async onEnd(event) {
    const { item, to, from, oldIndex, newIndex } = event
    if (to === from) return

    const ok = await this.patch(item.dataset.taskMoveUrl, { status: to.dataset.status })
    if (!ok) this.revert(item, from, oldIndex, newIndex)
  }

  revert(item, container, oldIndex, newIndex) {
    // Stessa formula corretta di pm_board_controller: nel same-container i
    // drag all'indietro spostano l'ancora originale a oldIndex + 1.
    const sameContainer = item.parentElement === container
    const index = sameContainer && newIndex < oldIndex ? oldIndex + 1 : oldIndex
    const reference = container.children[index]
    if (reference) {
      container.insertBefore(item, reference)
    } else {
      container.appendChild(item)
    }
  }

  async patch(url, body) {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify(body)
      })
      return response.ok
    } catch {
      return false
    }
  }
}
